<template>
<div>
  <div class="view_card courseWrap" style="margin-top:8px;background:#fff">
      <div class="courseWrap_header">
        <span>课程介绍</span>
        <!-- <div class="more">更多<i class="iconfont icon-right"></i></div> -->
      </div>
      <ul class="courseList" v-if="infoobj.courseInfo">
          <router-link to="/coursedetail">
        <li class="left" v-for="(item,index) in infoobj.courseInfo" :key="index">
            <div class="imgWrap">
            <van-image fit="cover" alt="" lazy-load>
                <template v-slot:loading>
                    <van-loading type="spinner" size="20" />
                </template>
            </van-image>
            </div>
            <div class="courseList_info">
            <p class="courseList_info-title ellipsis" title="">{{item.title}}</p>
            <p class="explain">适合月龄：{{item.minimum_month_age}}-{{maximum_month_age}}个月</p>
            <p class="intro" title="">亲自探索课为6-24个月畅享1111111</p>
            </div>
        </li>
        </router-link>
      </ul>
      <div v-else style="text-align:center">暂无</div>
  </div>
    <div class="view_card teacherWrap" style="margin-top:8px;background:#fff">
        <div class="teacherWrap_header">
            <span>师资介绍</span>
            <!-- <div class="more">更多<i class="iconfont icon-right"></i></div> -->
        </div> 
        <div class="teacherList" v-if="infoobj.teacherInfo">
      <div class="teacherItem" v-for="(item,index) in infoobj.teacherInfo" :key="index">
          <router-link to="/teacher">
        <van-image
          width="2.5rem"
          height="2.5rem"
          shape="square"
          :size="100"
          :src="item.photo"
          fit="cover"
          lazy-load
        >
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <p class="name">{{item.full_name}}</p>
        <p style="color:black">{{item.teach_age}}年教龄</p>
        </router-link>
      </div>
    </div>
    <div v-else style="text-align:center">暂无</div>
    </div>   
      <div class="view_card" style="margin-top:8px;background:#fff">
    <p class="title">联系我们</p>
    <div class="contact_item">
      <i class="iconfont icon-dizhi"></i>
      <!-- <a style="color:#666" :href="`https://uri.amap.com/marker?position=${bMapTransGMap.lng},${bMapTransGMap.lat}&name=${item.data.address}`">{{ item.data.address }}（距离<span class="dist">{{ item.data.distance }}</span>）</a> -->
    </div>
    <div class="contact_item">
      <i class="iconfont icon-phone"></i>
      <a style="color:#666">15</a>
    </div>
  </div>
    <div class="usWrap" style="margin-top:8px;background:#fff;padding-top:15px;box-sizing:border-box">
    <div class="usCont">
      <div class="headTitle">
        <div class="title_img"></div>
        <p>关于我们</p>
        <div></div>
        <div class="title_img"></div>
      </div>
      <div class="content btmBrief"></div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    props:['obj'],
    data () {
      return {
        infoobj:[]
      }
    },
    created(){
      console.log(this.obj,222)
    }
}
</script>

<style lang="stylus" scoped>
  @import "../static/css/global.styl"
  .courseWrap
    color #333
    padding 10px
    font-size 14px
    flex-direction column
    .noData
      height 40px
    .courseWrap_header
      width 100%
      display flex
      align-items center
      justify-content space-between
      margin 10px 0
      >span
        font-weight 700
        font-size 16px
      .more
        font-size 14px
        color #999
        display flex
        cursor: pointer;
        align-items center
        .iconfont
          line-height 14px
    .courseList
      margin-top 10px
      width 100%
      li
        display flex
        justify-content space-between
        width 100%
        /*height 120px*/
        margin-bottom 14px
        &:last-child
          margin-bottom 0
        >div
          width 50%
          flex-shrink 0
        .imgWrap
          height 104px
          overflow hidden
          display flex
          align-items center
          justify-content center
          img
            width auto
            height 100%
          img[lazy='error'],img[lazy='loading']
            width 50px
            height 50px
        .courseList_info
          padding 2px 0 0 10px
          .courseList_info-title
            font-size 15px
            color #666
            font-weight 700
          .explain
            line-height 22px
          .intro
            color #999
            font-size 12px
            line-height 17px
            margin-top 6px
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
    .course_vtc
      display flex
      flex-wrap wrap
      width 100%
      justify-content space-between
      li
        width 175px
        margin-top 10px
        .topImg
          width 100%
          height 100px
          overflow hidden
          margin-bottom 4px
          display flex
          align-items center
          justify-content center
          .van-image
            width 100%
            height 100%
          img[lazy='error'],img[lazy='loading']
            width 50px
            height 50px
        .name,.age,.brief
          padding 0 6px
        .age
          color #999
          font-size 12px
          margin 8px 0
        .brief
          margin-bottom 10px
          color #999
          font-size 12px
          line-height 16px
        .ellipsis
          max-width 100%
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
.teacherWrap
    color #333
    padding 10px
    font-size 14px
    flex-direction column
    .teacherWrap_header
      width 100%
      display flex
      align-items center
      justify-content space-between
      margin 10px 0
      >span
        font-weight 700
        font-size 16px
      .more
        font-size 14px
        color #999
        display flex
        cursor: pointer;
        align-items center
        .iconfont
          line-height 14px
    .teacherList
      width 100%
      display -webkit-box
      overflow-x auto
      & >>> .van-empty
        margin 0 auto
      .teacherItem
        padding-bottom 6px
        width 100px
        display flex
        margin-right 10px
        flex-direction column
        .name
          margin 6px 0
          font-size 14px
          color #666
          font-weight 700
        >p
          color #999
          font-size 14px
@import "../static/css/global.styl"
.view_card
  color #333 !important
  padding 20px 10px
  flex-direction column
  align-items flex-start !important

  .title
    margin-bottom 10px

  .contact_item
    margin-top 10px
    display flex
    align-items center
    > span
      line-height 20px
      font-size 14px

    .iconfont
      margin-top 3px
      color #999
      margin-right 10px

    .dist
      color $bgColor
@import "../static/css/global.styl"
.usWrap
  position relative
  .usCont
    width 100%
    margin-top 26px
    position relative
    border-radius 10px
    .headTitle
      display flex
      align-items center
      justify-content center
      & > p
        margin 0 10px
        font-size 14px
      .title_img
        width 48px
        height 16px
        background url("https://sucai.weizaojiao.cn/img/org-title-info.png") no-repeat center
        background-size 100% auto
        &:last-of-type
          transform rotate(-180deg)
    .content
      width 100%
      min-height 200px
      padding 10px
      >>>img
        width 100%
        height auto
</style>